<script>
  import { go } from '../lib/nav.svelte.js';
  import { mayVisit } from '../lib/session.svelte.js';

  let {
    children,
    variant = 'secondary',
    to = null, // internal route
    href = null, // external link (new tab)
    onclick = null,
    disabled = false,
    type = 'button',
  } = $props();

  // A button that navigates somewhere this login can't go is a promise the app
  // won't keep — the router would just bounce them back to the overview. Don't
  // offer it. Checked here rather than at each call site so every cross-screen
  // link is covered by construction.
  const reachable = $derived(to === null || mayVisit(to));

  function handle(e) {
    if (to) { e.preventDefault(); go(to); return; }
    if (onclick) onclick(e);
  }
</script>

{#if href}
  <a class="wf2-button {variant}" {href} target="_blank" rel="noreferrer">{@render children()}</a>
{:else if reachable}
  <button class="wf2-button {variant}" {type} {disabled} onclick={handle}>{@render children()}</button>
{/if}
